import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { FormikProps } from 'formik';

import { AgreementsForm } from 'common/forms';
import { Typography } from 'common/components';

import { QuestionTitle, PageControls } from '../../../../components';
import { setInvestingAgreementsValuesAction, selectInvestingAgreements, selectStrategy } from '../../../../ducks';
import { AgreementsFormValues } from 'common/models/Forms';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function InvestingAgreementsFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectInvestingAgreements);
  const strategy = useSelector(selectStrategy);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } =
    useFormStepContinueRef<AgreementsFormValues>();

  function handleBackClick() {
    navigate(-1);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<AgreementsFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: AgreementsFormValues) {
    if (!isPrivileged) {
      dispatch(setInvestingAgreementsValuesAction(values));
    }
    navigate(`/form/${id}/investing/pdf`);
  }

  return (
    <>
      <Typography.Title style={{ marginTop: '100px' }} level={1}>
        {strategy ? strategy.name : t('strategies.undefined')}
      </Typography.Title>
      <QuestionTitle>{t('investingFeature.agreements')}</QuestionTitle>
      <AgreementsForm onSubmit={handleSubmit} bindSubmit={bindSubmit} initialValues={initialValues || undefined} />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
